import {sharedIssueBaseStoreSelect} from "@shared/components/issues/store/shared-issue-base.selectors";

export const teamIssueStoreSelect = sharedIssueBaseStoreSelect;
